import { Ringtone } from '@/api';

export function useRingtone() {
  return {
    play: (type = 'call') => Ringtone.play(type),
    stop: () => Ringtone.stop(),
  };
}
